'use client';

import Button from '@ui/Button';
import { useEffect } from 'react';
import { useCreateListing } from '../_context';
import CategoryPicker, {
  applyCategoryToForm,
  useSelectedCategory,
} from './CategoryPicker';

export default function SelectListingCategory() {
  const { form, goToStep, categoryInfo } = useCreateListing();
  const sport = categoryInfo[0];
  const selected = useSelectedCategory();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleContinue = () => {
    if (!selected) {
      form.setError('category', {
        type: 'required',
        message: 'Please select a category',
      });
      return;
    }
    applyCategoryToForm(form, selected);
    goToStep('create-listing');
  };

  const handleBack = () => {
    goToStep('select-listing-sport');
    form.setValue('category1', null);
    form.setValue('category2', null);
    form.setValue('category3', null);
    form.clearErrors('category');
    form.clearErrors('category1');
    form.clearErrors('category2');
    form.clearErrors('category3');
  };

  return (
    <div className="mx-auto my-3 flex max-w-[100rem] flex-col gap-[2rem] px-[2rem] sm:my-[8rem]">
      <div className="flex w-full flex-col-reverse items-center justify-between gap-6 sm:flex-row">
        <h1 className="self-start text-[3rem] font-bold leading-[1.3] tracking-[-0.03rem] text-black">
          Which category is this item for?
        </h1>
        {sport && (
          <div className="flex shrink-0 items-center gap-[1rem] self-end text-[1.75rem] sm:self-center">
            <span className="font-medium text-[#444]">{sport.name}</span>
            <button
              type="button"
              onClick={handleBack}
              aria-label="Change sport"
              className="font-bold text-brand-secondary"
            >
              Change
            </button>
          </div>
        )}
      </div>

      <CategoryPicker autoFocus />

      {form.formState.errors?.category?.message && (
        <p className="text-[1.75rem] font-medium text-red-500">
          {form.formState.errors.category.message}
        </p>
      )}

      <div className="flex w-full flex-col-reverse gap-8 sm:flex-row">
        <Button text="Back" type="outline" width="fluid" onClick={handleBack} />
        <Button
          text="Continue"
          type="secondary"
          width="fluid"
          disabled={!selected}
          onClick={handleContinue}
        />
      </div>
    </div>
  );
}
